import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import WidgetsRender from "@widgets/render-engine";
import Layout from "@widgets/layout";
import { GetWidgetResponse } from "@helpers/fetch-json";
import LoadingSpinnerScreen from "./loading-screens/spinner-screen";

const WidgetInLocation = ({ widgets, location }) => {
    const shouldRender =
        (widgets &&
            widgets.filter((x) => x.data.renderLocation === location).length) >
        0;
    return shouldRender && <WidgetsRender data={widgets} location={location} />;
};

const PopupPage = (props) => {
    const routeParams = useParams();

    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [widgets, setWidgets] = useState(null);

    useEffect(() => {
        setLoading(true);
        if (props.path) {
            GetWidgetResponse(props.path, routeParams)
                .then((widgets) => {
                    setLoading(false);
                    setWidgets(widgets);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err);
                });
        }
    }, [id, props.path]);

    const mainWidget = useMemo(
        () => <WidgetsRender data={widgets} location="main" />,
        [widgets]
    );

    const bottomWidget = useMemo(
        () =>
            // Use widget in location as a method call (instead of widget),
            // as we need to know whether it is null in Layout.
            // If we pass through the 'tag' version, i.e. <WidgetInLocation ... />
            // the react element is never null (i.e. it is not 'evaluated' to null)
            WidgetInLocation({ widgets: widgets, location: "bottom" }),
        [widgets]
    );

    const bottomStickyWidget = useMemo(
        () =>
            WidgetInLocation({
                widgets: widgets,
                location: "sticky-bottom",
            }),
        [widgets]
    );

    return loading ? (
        <LoadingSpinnerScreen />
    ) : (
        <Layout
            main={mainWidget}
            bottom={bottomWidget}
            stickyBottom={bottomStickyWidget}
        />
    );
};

export default PopupPage;
